import { MdClose, MdOutlineSearch } from "react-icons/md";
import Button from "../Buttons/Button";
import { useEffect, useState } from "react";

interface ISearchBar {
    onSearch: (query: string) => void;
    onClear?: () => void;
    defaultValue: string;
    placeholder: string;
    disabledSearch?: boolean;
    cleanValue: boolean
}

const SearchBar = ({
    onSearch,
    defaultValue,
    placeholder,
    disabledSearch = true,
    onClear,
    cleanValue
}: ISearchBar) => {
    const [valueSearch, setValueSearch] = useState<string>(defaultValue);
    const [isDisabled, setIsDisabled] = useState(disabledSearch);

    useEffect(() => {
        setValueSearch(defaultValue);
    }, [defaultValue]);

    const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const val = e.target.value;
        setValueSearch(val);
        setIsDisabled(val.length === 0);

        if (val.length === 0 && cleanValue) {
            onSearch("");
            onClear?.();
        }
    };

    const handleClear = () => {
        setValueSearch("");
        setIsDisabled(true);
        onSearch("");
        onClear?.();
    };

    const triggerSearch = () => {
        onSearch(valueSearch);
        setIsDisabled(true);
    };

    const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === "Enter") {
            triggerSearch();
        }
    };

    return (
        <div className="flex items-center gap-2 h-[3.5rem] border border-system-light-50 rounded-sm px-4 hover:border-system-light-100 focus-within:outline-none focus-within:ring-2 focus-within:ring-primary-40 transition-colors duration-200">
            <MdOutlineSearch size={24} id='icon' className='ml-2' color='#40484C' />
            <input
                className="text-blarge text-system-light-100 w-full h-full rounded-sm placeholder:text-system-light-40 outline-none focus:border-brand-green-30"
                placeholder={placeholder}
                id="search"
                name="search"
                value={valueSearch}
                onChange={handleSearchChange}
                onKeyDown={handleKeyDown}
                aria-label="Buscar actividades"
            />
            {valueSearch && cleanValue && (
                <button
                    type="button"
                    onClick={handleClear}
                    className="text-system-light-40 hover:text-system-light-80 transition"
                    aria-label="Borrar búsqueda"
                >
                    <MdClose size={20} />
                </button>
            )}
        </div>
    );
};

export default SearchBar;